import { HostPoolsView } from "@/admin/host_pools/HostPoolsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/host_pools")({
    component: HostPoolsView,
});
